import IconWithText from './component.jsx'
export default IconWithText
